import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { easyexitInitialState } from "./states";
import axios from "axios";

const initialState = easyexitInitialState;

export const fetchEasyExitAsync = createAsyncThunk(
  "easyexit/Async",
  async (input, thunkApi) => {
    const { successCallback, errorCallback } = input;
    const { getState, rejectWithValue } = thunkApi;
    const { admin, easyexit } = getState();

    const config = {
      headers: {
        authorization: `Bearer ${admin.accessToken}`
      }
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_END_POINT}admin/getBizzSells?index=${easyexit?.index}&limit=${easyexit?.limit}&search=${easyexit?.search}&activated=${easyexit?.filters.approved}&new_easyexit=${easyexit?.filters.new_easyexit}&reported=${easyexit?.filters.reported}`,
        config
      );
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return {
        easyexit: response.data.content,
        totalCount: response.data.totalEasyExits
      };
    } catch (error) {
      errorCallback(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const EasyExitSlice = createSlice({
  name: "easyexit",
  initialState,
  reducers: {
    verified: (state, action) => {
      const { id, newData } = action.payload;
      const index = state.value.findIndex((bizz) => bizz._id === id);
      if (index !== -1) {
        state.value[index] = {
          ...state.value[index],
          ...newData
        };
      }
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setIndex: (state, action) => {
      state.index = action.payload;
    },
    setApproved: (state, action) => {
      state.filters.approved = action.payload;
    },
    setNewEasyExit: (state, action) => {
      state.filters.new_easyexit = action.payload;
    },
    setReported: (state, action) => {
      state.filters.reported = action.payload;
    },
    setSearchText: (state, action) => {
      state.search = action.payload;
    },
    clearFilter: (state) => {
      state.index = 0;
      state.filters.approved = null;
      state.filters.new_easyexit = true;
      state.filters.reported = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEasyExitAsync.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchEasyExitAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.value = action.payload.easyexit;
      state.totalCount = action.payload.totalCount;
    });
    builder.addCase(fetchEasyExitAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  }
});

export default EasyExitSlice.reducer;
export const {
  verified,
  setIndex,
  setLimit,
  setApproved,
  setNewEasyExit,
  clearFilter,
  setReported,
  setSearchText
} = EasyExitSlice.actions;
